(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("6SrTN", function(module, exports) {

var $1FCkY = parcelRequire("1FCkY");

var $8h94B = parcelRequire("8h94B");
const $501d6d5ae92a0581$var$advertSliders = document.querySelectorAll(".g-advert.--slider");
$501d6d5ae92a0581$var$advertSliders.forEach((slider)=>{
    const swiperSettings = {
        modules: [
            (0, $8h94B.Keyboard),
            (0, $8h94B.Pagination),
            (0, $8h94B.Autoplay)
        ],
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true
        },
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 16,
        keyboard: {
            enabled: true
        },
        pagination: {
            el: slider.querySelector(".g-advert__pagination"),
            clickable: true
        },
        on: {
            init: ()=>{
                slider.classList.remove("--loading");
            }
        }
    };
    new (0, $1FCkY.default)(slider, swiperSettings);
});

});

})();
//# sourceMappingURL=advert-group--slider.fea0b6f9.js.map
